// Emoji 分類常量
export const EMOJI_CATEGORIES: Record<string, string[]> = {
  '表情': [
    '😊', '😃', '😎', '🤓', '🧐', '😇', '🥳', '🤩',
    '😄', '😁', '😆', '😋', '😍', '🤗', '🤔', '😴',
    '😌', '😏', '😉', '🙂', '😀', '😅', '😂', '🤣',
    '😢', '😭', '😤', '😡', '😱', '😨', '😰', '😥',
    '😓', '😪', '🤤', '😵', '🤯', '🥶', '🥵', '😷',
    '🤒', '🤕', '🤢', '🤮', '🤧', '🥴', '😵‍💫', '🤠'
  ],
  '人物': [
    '👦', '👧', '🧒', '👨', '👩', '👶', '🧑', '👱',
    '👴', '👵', '👨‍🦱', '👩‍🦱', '👨‍🦰', '👩‍🦰', '👨‍🦳', '👩‍🦳',
    '👨‍🦲', '👩‍🦲', '🧔', '👱‍♂️', '👱‍♀️', '🧓', '👲', '👳',
    '👳‍♂️', '👳‍♀️', '🧕', '👮', '👮‍♂️', '👮‍♀️', '👷', '👷‍♂️',
    '👷‍♀️', '💂', '💂‍♂️', '💂‍♀️', '🕵️', '🕵‍♂️', '🕵‍♀️', '👩‍⚕️',
    '👨‍⚕️', '👩‍🌾', '👨‍🌾', '👩‍🍳', '👨‍🍳', '👩‍🎓', '👨‍🎓', '👩‍🎤',
    '👨‍🎤', '👩‍🏫', '👨‍🏫', '👩‍🏭', '👨‍🏭', '👩‍💻', '👨‍💻', '👩‍💼',
    '👨‍💼', '👩‍🔧', '👨‍🔧', '👩‍🔬', '👨‍🔬', '👩‍🎨', '👨‍🎨', '👩‍🚒',
    '👨‍🚒', '👩‍✈️', '👨‍✈️', '👩‍🚀', '👨‍🚀', '👩‍⚖️', '👨‍⚖️', '🤶',
    '🎅', '🧙', '🧙‍♂️', '🧙‍♀️', '🧚', '🧚‍♂️', '🧚‍♀️', '🧛',
    '🧛‍♂️', '🧛‍♀️', '🧜', '🧜‍♂️', '🧜‍♀️', '🧝', '🧝‍♂️', '🧝‍♀️',
    '🧞', '🧞‍♂️', '🧞‍♀️', '🧟', '🧟‍♂️', '🧟‍♀️'
  ],
  '角色': [
    '🦸', '🦸‍♂️', '🦸‍♀️', '🦹', '🦹‍♂️', '🦹‍♀️',
    '🤴', '👸', '🤵', '👰', '🤵‍♂️', '👰‍♀️',
    '🤰', '🤱', '👼', '🎭', '🩰', '🎪'
  ],
  '動物': [
    '🦁', '🐯', '🐰', '🐻', '🐼', '🐨', '🐶', '🐱',
    '🐸', '🐷', '🐮', '🐭', '🐹', '🦊', '🐺', '🐻‍❄️',
    '🦓', '🦄', '🐴', '🐎', '🦌', '🦬', '🐂', '🐃',
    '🐄', '🐆', '🐅', '🐊', '🐉', '🐲', '🦕', '🦖',
    '🐢', '🐍', '🦎', '🐙', '🦑', '🦐', '🦞', '🦀',
    '🐡', '🐠', '🐟', '🐬', '🐳', '🐋', '🦈',
    '🦍', '🦧', '🐘', '🦛', '🦏', '🐪', '🐫', '🦒',
    '🦘', '🐖', '🐏', '🐑',
    '🦙', '🐐', '🐕', '🐩', '🦮', '🐕‍🦺', '🐈',
    '🐈‍⬛', '🐓', '🦃', '🦤', '🦚', '🦜', '🦢', '🦩',
    '🕊️', '🐇', '🐁', '🐀', '🐿️', '🦫', '🦔', '🦇',
    '🦥', '🦦', '🦨', '🦡', '🐾'
  ],
  '食物': [
    '🍎', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍈',
    '🍒', '🍑', '🥭', '🍍', '🥥', '🥝', '🍅', '🍆',
    '🥑', '🥦', '🥬', '🥒', '🌶️', '🌽', '🥕', '🥔',
    '🍠', '🥐', '🥯', '🍞', '🥖', '🥨', '🧀', '🥚',
    '🍳', '🥞', '🥓', '🥩', '🍗', '🍖', '🦴', '🌭',
    '🍔', '🍟', '🍕', '🥪', '🥙', '🌮', '🌯', '🥗',
    '🥘', '🥫', '🍝', '🍜', '🍲', '🍛', '🍣', '🍱',
    '🥟', '🥠', '🥡', '🍙', '🍚', '🍘', '🍥', '🥮',
    '🍢', '🍡', '🍧', '🍨', '🍦', '🥧', '🍰', '🎂',
    '🍮', '🍭', '🍬', '🍫', '🍿', '🍩', '🍪', '🌰',
    '🥜', '🍯', '🥛', '🍼', '☕️', '🍵', '🧃', '🥤',
    '🍶', '🍺', '🍻', '🥂', '🍷', '🥃', '🍸', '🍹',
    '🧉', '🍾', '🧊'
  ],
  '活動': [
    '⚽️', '🏀', '🏈', '⚾️', '🥎', '🎾', '🏐', '🏉',
    '🥏', '🎱', '🏓', '🏸', '🏒', '🏑', '🥍', '🏏',
    '🥅', '⛳️', '🏹', '🎣', '🥊', '🥋', '🎽', '🛹',
    '🛷', '⛸️', '🥌', '🎿', '⛷️', '🏂', '🏋️', '🤼',
    '🤸', '🤺', '🧘', '🏄', '🏊', '🤽', '🚣', '🧗',
    '🚵', '🚴', '🏇', '🤹', '🤾', '🏌️', '🏃', '🚶',
    '🧍', '🧎', '🏃‍♂️', '🏃‍♀️', '🚶‍♂️', '🚶‍♀️', '💃', '🕺',
    '🕴️', '👯', '👯‍♂️', '👯‍♀️', '🧖', '🧖‍♂️', '🧖‍♀️', '🧗',
    '🧗‍♂️', '🧗‍♀️', '🤺', '🏇', '⛷️', '🏂', '🏌️', '🏌️‍♂️',
    '🏌️‍♀️', '🏄', '🏄‍♂️', '🏄‍♀️', '🚣', '🚣‍♂️', '🚣‍♀️', '🏊',
    '🏊‍♂️', '🏊‍♀️', '⛹️', '⛹️‍♂️', '⛹️‍♀️', '🏋️', '🏋️‍♂️', '🏋️‍♀️',
    '🚴', '🚴‍♂️', '🚴‍♀️', '🚵', '🚵‍♂️', '🚵‍♀️', '🤸', '🤸‍♂️',
    '🤸‍♀️', '🤼', '🤼‍♂️', '🤼‍♀️', '🤽', '🤽‍♂️', '🤽‍♀️', '🤾',
    '🤾‍♂️', '🤾‍♀️', '🤹', '🤹‍♂️', '🤹‍♀️', '🧘', '🧘‍♂️', '🧘‍♀️'
  ],
  '獎勵': [
    '⭐', '🌟', '💫', '✨', '🎉', '🎊', '🎈', '🎁',
    '🏆', '🥇', '🥈', '🥉', '🎖️', '🏅', '🎗️', '🎫',
    '🎟️', '💎', '👑', '🏵️'
  ],
  '交通工具': [
    '🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑',
    '🚒', '🚐', '🛻', '🚚', '🚛', '🚜', '🏍️', '🛵',
    '🚲', '🛴', '🛹', '🛼', '🚁', '🛸', '✈️', '🛩️',
    '🛫', '🛬', '🪂', '💺', '🚀', '🚢', '⛵', '🛥️',
    '🛳️', '⛴️', '🚤', '🛶', '🛟', '⛽', '🚨', '🚥',
    '🚦', '🚧', '🛑', '⚓', '🪝', '🚂', '🚃', '🚄',
    '🚅', '🚆', '🚇', '🚈', '🚉', '🚊', '🚝', '🚞',
    '🚟', '🚠', '🚡', '🛰️'
  ],
  '建築': [
    '🗺️', '🧭', '🛤️', '🛣️', '🗿', '🛕', '⛩️', '🕍',
    '⛪', '🕌', '🕋', '⛲', '⛺', '🌁', '🏗️', '🧱',
    '🏘️', '🏚️', '🏠', '🏡', '🏢', '🏣', '🏤', '🏥',
    '🏦', '🏨', '🏩', '🏪', '🏫', '🏬', '🏭', '🏯',
    '🏰', '💒', '🗼', '🗽', '🌃', '🏙️', '🌄', '🌅',
    '🌆', '🌇', '🌉', '♨️', '🎠', '🎡', '🎢', '💈',
    '🎪'
  ],
  '樂器': [
    '🎤', '🎧', '🎼', '🎹', '🥁', '🎷', '🎺', '🎸',
    '🪕', '🎻', '🪘', '🪗', '🎵', '🎶', '🎙️', '🎚️',
    '🎛️', '🎜', '🎝', '🎞️', '🎟️'
  ],
  '遊戲': [
    '🎲', '♟️', '🎯', '🎳', '🎮', '🎰', '🧩', '🃏',
    '🀄', '🎴', '🎭', '🖼️', '🎨', '🖌️', '🖍️', '✏️',
    '✒️', '🖊️', '🖋️', '📝', '💼', '📁', '📂',
    '🗂️', '📅', '📆', '🗒️', '🗓️', '📇', '📈', '📉',
    '📊', '📋', '📌', '📍', '📎', '🖇️', '📏', '📐',
    '✂️', '🗃️', '🗄️', '🗑️'
  ]
}

// 獲取所有 Emoji（用於搜索）
export const getAllEmojis = (): string[] => {
  return Object.values(EMOJI_CATEGORIES).flat()
}

// 查找 Emoji 所屬的分類
export const findEmojiCategory = (emoji: string): string | null => {
  for (const [category, emojis] of Object.entries(EMOJI_CATEGORIES)) {
    if (emojis.includes(emoji)) {
      return category
    }
  }
  return null
}

